import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Host-selected Live roles: exactly one Admin (red) + unlimited Moderators (blue). Session-scoped.
export const ROLE_STYLE = {
  admin: { label: "Admin", name: "text-red-400", chip: "bg-red-600 text-white" },
  moderator: { label: "Moderator", name: "text-sky-400", chip: "bg-sky-500 text-white" },
};

export const ROLES_CHANGED_EVENT = "live:roles-changed";
export const notifyRolesChanged = () => window.dispatchEvent(new CustomEvent(ROLES_CHANGED_EVENT));

export function useLiveRoles(streamId) {
  const [roles, setRoles] = useState({});
  const load = useCallback(async () => {
    if (!streamId) return;
    try {
      const { data } = await api.get(`/live/${streamId}/roles`);
      const next = {};
      for (const r of data?.roles || []) next[r.user_id] = r.role;
      setRoles(next);
    } catch { /* ignore */ }
  }, [streamId]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    window.addEventListener(ROLES_CHANGED_EVENT, load);
    return () => window.removeEventListener(ROLES_CHANGED_EVENT, load);
  }, [load]);
  return { roles, reload: load };
}

export function roleNameClass(role, fallback = "") {
  return ROLE_STYLE[role]?.name || fallback;
}

export function RoleLabel({ role, size = "xs" }) {
  const s = ROLE_STYLE[role];
  if (!s) return null;
  const dim = size === "xs" ? "text-[8px] px-1" : "text-[10px] px-1.5 py-0.5";
  return <span data-testid={`live-role-label-${role}`} className={`uppercase tracking-widest rounded-sm font-semibold ${dim} ${s.chip}`}>{s.label}</span>;
}
